import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/global/ProtectedRoute';
import HomeSectionsList from '../pages/home_sections/HomeSectionsList';
import CreateHomeSection from '../pages/home_sections/CreateHomeSection';
import EditHomeSection from '../pages/home_sections/EditHomeSection';

const homeSectionsRoutes = (
    <>
        {/* Home Sections List */}
        <Route
            path="/home-sections"
            element={
                <ProtectedRoute requiredPermission="cms.manage">
                    <HomeSectionsList />
                </ProtectedRoute>
            }
        />

        {/* Create Home Section */}
        <Route
            path="/home-sections/create"
            element={
                <ProtectedRoute requiredPermission="cms.manage">
                    <CreateHomeSection />
                </ProtectedRoute>
            }
        />

        {/* Edit Home Section */}
        <Route
            path="/home-sections/:id/edit"
            element={
                <ProtectedRoute requiredPermission="cms.manage">
                    <EditHomeSection />
                </ProtectedRoute>
            }
        />
    </>
);

export default homeSectionsRoutes;
